import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef } from 'react';
import '../../../styles/game/InfoBoard.css';
import '../../../styles/game/InfoBoardTabs.css';
import '../../../styles/game/InfoBoardComponents.css';
import FairnessModal from "../FairnessModal";
import { t } from "i18next";


function BiggestWins({isDay, setIsDay, isMonth, setIsMonth, isYear, setIsYear, mainWallet}) {



    const [isLoading, setIsLoading] = useState(true)
    const [isFairnessOpen, setIsFairnessOpen] = useState(false)
    const [roundId, setRoundId] = useState(0)
    const [biggestWins, setBiggestWins] = useState([])
    const [isOption, setIsOption] = useState(() => {
        if (isDay) return 'day';
        if (isMonth) return 'month';
        if (isYear) return 'year';
    });

    const sliderRef = useRef(null);

    useEffect(() => {

            if (isDay) {
                setIsOption('day')
            } else if (isMonth) {
                setIsOption('month')
            } else if (isYear) {
                setIsOption('year')
            }
    }, [isDay, isMonth, isYear]);

    

    const closeFairnessModal = () => {
        setTimeout(() => {
            setIsFairnessOpen(false);
        }, 200)
    }


    useEffect(() => {
        setIsLoading(true)
        setBiggestWins([])
        const fetchMyBetsHistory = async () => {

            try {
                const response = await fetch(`${import.meta.env.VITE_API_URL}/api/biggest-wins`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ option: isOption }), // Передаем userId в теле запроса
                });

                if (!response.ok) {
                    throw new Error(`Ошибка HTTP: ${response.status}`);
                }
                if (response.ok) {
                    const data = await response.json(); // Парсим ответ
                   
                    setBiggestWins(data.result)
                    setIsLoading(false)
                }

            } catch (error) {
                console.error('Ошибка при выполнении запроса:', error);
            }
        };

        fetchMyBetsHistory();
        
    }, [isOption]); // Добавляем isUserId в зависимости


    const handleNavClick = (tab) => {
        setIsDay(tab === "allBets");
        setIsMonth(tab === "myBets");
        setIsYear(tab === "top");
    };


    function getDateDay(date) {
        const [datePart, timePart] = date.split('T');
        const dateParse = new Date(datePart)
        const options = { day: '2-digit', month: 'short' };
        const result = dateParse.toLocaleDateString('en-US', options)
        const resultArr = result.split(' ');
        return `${resultArr[1]}`
    }

    function getDateMonth(date) {
        const [datePart, timePart] = date.split('T');
        const dateParse = new Date(datePart)
        const options = { day: '2-digit', month: 'short' };
        const result = dateParse.toLocaleDateString('en-US', options)
        const resultArr = result.split(' ');
        return `${resultArr[0]}`
    }

    function getTime(date) {
        const [datePart, timePart] = date.split('T');
        const timeParts = timePart.split('.')
        return timeParts[0]
    }
    
    function getColor(value) {
        let color = "rgb(52, 180, 255)";
        const parseCashout = parseFloat(value)

        if (parseCashout >= 2.00 && parseCashout < 10.00) {
            color = "rgb(145, 62, 248)"
          } else if (parseCashout >= 10.00) {
            color = "rgb(192, 23, 180)"
          }

          return {"color": color}
    }

    function calculate(num) {
        let parseNum = parseFloat(num)
        let wallet = mainWallet
        let rates = {
            uzs: 1,
            rub: 150.12,
            usd: 0.08,
        }
        let result
        if(wallet === 'uzs') {
            result = parseNum * rates[wallet]
        } else if(wallet === 'usd') {
            result = parseNum / 13000
        } else if (wallet === 'rub') {
            result = parseNum / 150
        }
        return new Intl.NumberFormat('en-US', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(result)
    }

    return (
        <>
            {/* <div className={'top-tab-switcher'}>

                <div className={'navigation-switcher'}>
                    <button className={`nav-tab ${isDay ? "active" : ""}`}
                            onClick={() => handleNavClick('allBets')}>{t("Day")}
                    </button>
                    <button className={`nav-tab ${isMonth ? "active" : ""}`}
                            onClick={() => handleNavClick('myBets')}>{t("Month")}
                    </button>
                    <button className={`nav-tab ${isYear ? "active" : ""}`}
                            onClick={() => handleNavClick('top')}>{t("Year")}
                    </button>
                </div>

            </div> */}
            {/* <div className={'bet-component-wrapper'}>
                    <div className={'bet-component-body'}>
                        <div className={'multiplier-fairness top'}></div>
                        <div className={'bet-component-user-avatar'}>
                            <img src="/assets/img/avatars/av-7.png" alt=""/>
                            <div className={'line-height-15'}>2**7</div>
                        </div>
                        <div className={'bet-component-bet-info'}>
                            <div className={'bet-component-bet-info-content'}>
                                <div className={'d-flex align-items-center line-height-15'}>
                                    <div className={'ml-20 d-flex justify-content-end w-50'}>
                                        Bet USD:
                                    </div>
                                    <span className={'ml-5 color-white font-size-14'}>50.00</span>
                                </div>
                                <div className={'d-flex align-items-center line-height-15'}>
                                    <div className={'ml-20 d-flex justify-content-end w-50'}>
                                        Win USD:
                                    </div>
                                    <span className={'biggest-win-amount-celebrated'}>5,550.00</span>
                                </div>
                                <div className={'d-flex align-items-center line-height-15'}>
                                    <div className={'ml-20 d-flex justify-content-end w-50'}>
                                        Multiplier:
                                    </div>
                                    <div className={'multiplier-info-result font-size-12'}>
                                            1,205.20x
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={'bet-component-footer'}>
                        <div className={'d-flex'}>
                            <div className={'huge-wins-date'}>
                                <span>09</span>
                                <span>Mar</span>
                            </div>
                            <div className={'line-height-15'}>
                                <span>Round 8840.53x</span>
                                
                            </div>
                        </div>
                        <div className={'bet-shared-icon'}>
                            <div className={'bet-shared-icon-button'}></div>
                        </div>
                    </div>
                </div> */}

            <div className={'real-time-bets-wrapper rounds'}>
            {isLoading ? <div className={`archive-loader-wrap show mybets-all`}>
                                <span className={'archive-loader'}></span>
                                </div> : ""
                            } 
                {biggestWins.length > 0 ? (
                    biggestWins.map((item, index) => (
                        <div key={index} className={'bet-component-wrapper'}>
                        <div className={'bet-component-title-wrap'}>
                            <img src={item.user.userAvatarUrl} alt=""/>
                            <div className={'bet-component-username-date'}>
                                <div className={'bet-component-title-username'}>{item.user.aviatorId[0]}***{item.user.aviatorId[7]}</div>
                                <div style={{"color": "#7a7a7a"}}>{getTime(item.createdAt)}</div>
                            </div>
                            <div className={'bet-component-buttons-group'}>
                                    <button className={'bet-component-buttons-group-btn'} style={{"margin-right": "8px"}}>
                                        <img src="/assets/img/message-icon.svg" alt="" />
                                    </button>
                                    <button className={'bet-component-buttons-group-btn'} onClick={() => {
                                setRoundId(item.roundId)
                                setIsFairnessOpen(true)
                            
                            }}>
                                        <img src="/assets/img/shield-icon.svg" alt="" />
                                    </button>
                            </div>
                        </div>
                        <div className={'bet-component-body-wrap'}>
                            <div className={'bet-component-info-column'} style={{"marginRight": "8px"}}>
                                <div className={'bet-component-info-row'}>
                                    <div className={'bet-component-info-description'}>{t("bet")} {mainWallet ? mainWallet.toUpperCase() : ""}</div>
                                    <div className={'bet-component-info-value'}>{calculate(item.bet)}</div>
                                </div>
                                <div className={'bet-component-info-row'}>
                                    <div className={'bet-component-info-description'}>{t("win")} {mainWallet ? mainWallet.toUpperCase() : ""}</div>
                                    <div className={'bet-component-info-value'}>{calculate(item.cashout)}</div>
                                </div>
                            </div>
                            <div className={'bet-component-info-column'}>
                                <div className={'bet-component-info-row'}>
                                    <div className={'bet-component-info-description'}>Result</div>
                                    <div className={'bet-component-info-value'} style={getColor(item.celebrated)}>{item.celebrated}x</div>
                                </div>
                                <div className={'bet-component-info-row'}>
                                    <div className={'bet-component-info-description'}>Round max</div>
                                    <div className={'bet-component-info-value'} style={item.round !== null ? getColor(item.round.roundResult) : {}}>{item.round !== null ? item.round.roundResult : ""}x</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    ))
                ) : ""}
            </div>
            {isFairnessOpen && <FairnessModal isOpen={isFairnessOpen} onClose={closeFairnessModal} roundId={roundId}/>}
        </>
    )
}

export default BiggestWins;